import useHookForm from '../../../hooks/forms/useHookForm'
import { validationSchema } from './schema'
import { DEFAULT_VALUES, ERROR_MESSAGES } from './constants'
import { getAccessKey } from 'services/authenticationService'
import MODAL from 'src/utils/modals'

const useForm = () => {
  const handleAccesKey = async ({ email, successCallback, context, setError }) => {
    try {
      context.showLoader()
      const accessKeyResponse = await getAccessKey(email)
      if (accessKeyResponse.status === 200) {
        const { authenticationToken } = accessKeyResponse.data
        context.setResetPasswordData({ email, authenticationToken: authenticationToken })
        if (successCallback) {
          successCallback(MODAL.RESET_PASSWORD_MODAL({
            onCancel: successCallback,
            callback: successCallback
          }))
        }
      } else {
        const errorStatus = accessKeyResponse?.response?.status
        setError('email', {
          type: 'manual',
          message: ERROR_MESSAGES[errorStatus] || ERROR_MESSAGES.DEFAULT
        })
      }
    } catch (error) {
      console.error('error', error)
    } finally {
      context.hideLoader()
    }
  }

  const onSubmitForm = (values, params) => {
    const { successCallback, context, setError } = params
    const { email } = values
    handleAccesKey({ email, successCallback, context, setError })
  }

  const form = useHookForm({
    onSubmitForm,
    validationSchema,
    defaultValues: DEFAULT_VALUES
  })

  return form
}

export default useForm
